const Main = () => import ('../views/main/main.vue')
export default [{
  path: '/kcgl',
  component: Main,
  redirect: '',
  meta: {
    title: '库存业务',
    icon: 'guide'
  },
  children: [
  ]
}]
